import { render } from "./Rolling.vue?vue&type=template&id=4d3b0f3d&scoped=true"
import script from "./Rolling.vue?vue&type=script&lang=js"
export * from "./Rolling.vue?vue&type=script&lang=js"

import "./Rolling.vue?vue&type=style&index=0&id=4d3b0f3d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3b0f3d"]])

export default __exports__